module.exports = __webpack_public_path__ + "img/pintecFlexible.ced423d0.png";